import moment from 'moment';
import config from "./config";
moment.locale(config.locale);
export {moment};
